import type { ReactElement } from 'react'
import { WidgetListItems } from '../../util/sidebar'
import Watchlists from '../watchlist/Watchlist'
import AlertsSidebar from '../alerts/alertsSidebar/AlertsSidebar'
import MarketNews from '../news/MarketNews'
import PositionsWidget from '../postionsWidget'
import TradeWidget from '../TradePanel/tradeWidget'
import OrdersWidget from '../ordersWidget'
import HoldingsWidget from '../holdings/HoldingsWidget'
import AiAssistantPanel from '../aiAssistant/AiAssistantPanel'

/** Stable element references so WidgetbarPageShell memo is not broken on parent re-renders. */
export const WIDGETBAR_VIEW_ELEMENTS: Partial<Record<WidgetListItems, ReactElement>> = {
    [WidgetListItems.WATCHLIST]: <Watchlists />,
    [WidgetListItems.ALERT]: <AlertsSidebar />,
    [WidgetListItems.MARKET_NEWS]: <MarketNews />,
    [WidgetListItems.POSITIONS]: <PositionsWidget />,
    [WidgetListItems.TRADE]: <TradeWidget />,
    [WidgetListItems.ORDERS]: <OrdersWidget />,
    [WidgetListItems.HOLDINGS]: <HoldingsWidget />,
    [WidgetListItems.AI_ASSISTANT]: <AiAssistantPanel />,
}
